import { type AppConfigBase } from 'ecosystem'
import { useUIGlobalsContext } from '../lib/ui-globals/hooks'

export const useAppPaths = () => {
  const { appPaths } = useUIGlobalsContext()

  return appPaths as AppConfigBase['paths'] | undefined // this can be undefined in case the app is not wrapped with
  // the UIGlobals (like in the case of the GS apps
}
